"use client";

import FocusSvg from "../../assets/animations/focus.animated.svg";
import { SvgAnimation, type SvgAnimationProps } from "../svg-animation/svg-animation";

export function FocusAnimation(props: SvgAnimationProps) {
  return <SvgAnimation {...props} svg={FocusSvg} />;
}
